import capitalize from 'lodash/capitalize';

import { EFilterColor } from '@/shared/consts/filters';

import { IFilterColorSelectItem } from 'types/filters/common';

export enum SwapStatus {
  Pending = 'pending',
  Processing = 'processing',
  Success = 'success',
  Failed = 'failed',
  Error = 'error',
  Canceled = 'canceled',
}

export const SWAP_STATUSES: IFilterColorSelectItem[] = [
  {
    value: SwapStatus.Canceled,
    label: capitalize(SwapStatus.Canceled),
    color: EFilterColor.blue_6,
  },
  {
    value: SwapStatus.Error,
    label: capitalize(SwapStatus.Error),
    color: EFilterColor.red_1,
  },
  {
    value: SwapStatus.Failed,
    label: capitalize(SwapStatus.Failed),
    color: EFilterColor.pink_4,
  },
  {
    value: SwapStatus.Pending,
    label: capitalize(SwapStatus.Pending),
    color: EFilterColor.orange_4,
  },
  {
    value: SwapStatus.Processing,
    label: capitalize(SwapStatus.Processing),
    color: EFilterColor.yellow_1,
  },
  {
    value: SwapStatus.Success,
    label: capitalize(SwapStatus.Success),
    color: EFilterColor.green_2,
  },
];
